import React from 'react';
import styles from "../styles/Login.module.css";

const PrivacyPolicy = () => (
    <ul className={styles.ul}>
      <li>
        <strong>제1조 (목적)</strong>
        <ol>
        <li>이 약관은 <strong>Ongil</strong> (이하 "온길")가 제공하는 서비스의 이용과 관련하여
        회원가입 및 이용에 필요한 사항을 규정하는 것을 목적으로 합니다.</li>
        </ol>
      </li>

      <li>
        <strong>제2조 (정의)</strong><br />
        <ol>
        <li><strong>"서비스"</strong>란 온길이 제공하는 웹사이트, 애플리케이션 등 모든 온라인 서비스를 의미합니다.</li>
        <li><strong>"회원"</strong>이란 본 약관에 동의하고 온길의 서비스를 이용하는 이용자를 의미합니다.</li>
        <li><strong>"이용계약"</strong>이란 회원이 본 약관에 동의하고 온길이 이를 승낙함으로써 체결되는 계약을 의미합니다.</li>
        <li><strong>"아이디(ID)"</strong>란 회원의 식별을 위해 회원이 설정한 고유한 문자와 숫자의 조합을 의미합니다.</li>
        <li><strong>"비밀번호"</strong>란 회원의 개인 정보 보호를 위해 설정한 비밀 번호를 의미합니다.</li>
        </ol>
      </li>

      <li>
        <strong>제3조 (이용약관의 효력)</strong><br />
        <ol><li>본 약관은 온길의 서비스에 회원가입을 완료한 때부터 효력이 발생합니다.
        온길은 본 약관의 내용을 변경할 수 있으며, 변경된 내용은
        서비스 화면에 공지하거나 이메일을 통해 회원에게 알려야 합니다.</li></ol>
      </li>

      <li>
        <strong>제4조 (회원가입)</strong><br />
        <ol><li>회원가입은 회원이 본 약관에 동의하고, 온길이 요구하는 개인정보를 제공하는 절차를 거쳐야 합니다.
        회원가입 신청자는 반드시 본인 정보를 정확히 제공해야 하며,
        허위 정보 제공 시 회원 자격을 상실할 수 있습니다.</li></ol>
      </li>

      <li>
        <strong>제5조 (개인정보 보호)</strong><br />
        <ol><li>온길은 개인정보 보호법 등 관련 법령을 준수하며,
        회원의 개인정보를 보호하기 위해 최선을 다합니다.
        개인정보 처리방침에 대해서는 별도의 문서로 공지됩니다.</li></ol>
      </li>

      <li>
        <strong>제6조 (회원의 의무)</strong><br />
        <ol><li>회원은 본 약관 및 관련 법규를 준수하여야 하며,
        온길의 서비스를 이용함에 있어 타인의 권리를 침해하지 않아야 합니다.
        회원은 아이디와 비밀번호를 안전하게 관리하고, 이를 제3자에게 제공하지 않아야 합니다.</li></ol>
      </li>

      <li>
        <strong>제7조 (서비스의 제공 및 변경)</strong><br />
        <ol><li>온길은 서비스의 운영상 필요에 따라 서비스를 변경하거나 중지할 수 있습니다.
        서비스의 변경 또는 중지에 대해 온길은 사전 공지를 통해 회원에게 통지합니다.</li></ol>
      </li>

      <li>
        <strong>제8조 (이용 계약의 해지)</strong><br />
        <ol><li>회원은 언제든지 본인의 계정을 해지할 수 있습니다.
        온길은 회원이 본 약관을 위반했을 경우,
        사전 통지 없이 이용계약을 해지할 수 있습니다.</li></ol>
      </li>

      <li>
        <strong>제9조 (책임의 제한)</strong><br />
        <ol><li>온길은 서비스의 이용에 있어 발생한 문제에 대해 그 책임을 지지 않으며,
        회원이 서비스를 이용하는 동안 발생한 손해에 대해서도 책임을 지지 않습니다.</li></ol>
      </li>

      <li>
        <strong>제10조 (기타)</strong><br />
        <ol><li>본 약관은 대한민국 법률에 따라 해석되며,
        관련 분쟁 발생 시 온길 본사의 주소지를 관할하는 법원에서 해결됩니다.
        본 약관에 명시되지 않은 사항에 대해서는 관련 법령 또는 온길의 정책에 따릅니다.</li></ol>
      </li>
    </ul>
);

export default PrivacyPolicy;